import { useState, useEffect } from "react";
import { Btn, Card, Inp, ConfirmModal } from "../ui";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";

var SIGTE_BRAND = "#0F2C70";
var CATEGORIAS = [["marca","Marca"],["tipo","Tipo"],["estado","Estado"]];

export function SigteCatalogos() {
  var [catalogos,setCatalogos]=useState([]);
  var [loading,setLoading]=useState(true);
  var [tab,setTab]=useState("marca");
  var [nuevo,setNuevo]=useState("");
  var [err,setErr]=useState("");
  var [confirmData,setConfirmData]=useState(null);
  var [editingId,setEditingId]=useState(null);
  var [editingValor,setEditingValor]=useState("");

  function load(){
    sigteApiFetch("/catalogos").then(function(r){return r.json();}).then(function(d){
      setCatalogos(d.catalogos||[]); setLoading(false);
    });
  }
  useEffect(load,[]);

  function ask(msg,fn){ setConfirmData({msg:msg,fn:fn}); }

  async function add(){
    if(!nuevo.trim()){setErr("Escribe un valor.");return;}
    setErr("");
    try {
      await sigteApiFetchChecked("/catalogos",{method:"POST",body:JSON.stringify({categoria:tab,valor:nuevo.trim()})});
      setNuevo(""); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  async function toggleActivo(c){
    try {
      await sigteApiFetchChecked("/catalogos/"+c.id,{method:"PUT",body:JSON.stringify({activo:!c.activo})});
      load();
    } catch(e) {
      setErr(e.message);
    }
  }

  function startEdit(c){ setEditingId(c.id); setEditingValor(c.valor); setErr(""); }
  async function saveEdit(c){
    if(!editingValor.trim()){setErr("El valor no puede estar vacio.");return;}
    try {
      await sigteApiFetchChecked("/catalogos/"+c.id,{method:"PUT",body:JSON.stringify({valor:editingValor.trim()})});
      setEditingId(null); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  function del(c){
    ask('Eliminar "'+c.valor+'"?', async function(){
      try {
        await sigteApiFetchChecked("/catalogos/"+c.id,{method:"DELETE"});
        load();
      } catch(e) {
        setErr(e.message);
      }
    });
  }

  if(loading) return <p style={{color:"#64748b",fontSize:14}}>Cargando...</p>;

  var rows = catalogos.filter(function(c){return c.categoria===tab;});

  return (
    <div>
      <ConfirmModal data={confirmData} onCancel={function(){setConfirmData(null);}} onConfirm={function(){if(confirmData)confirmData.fn();setConfirmData(null);}}/>
      <div style={{marginBottom:24}}>
        <h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>Catalogos</h1>
        <p style={{color:"#64748b",fontSize:13,marginTop:3}}>Marca, tipo y estado de equipos.</p>
      </div>
      <div style={{display:"flex",gap:4,marginBottom:20,background:"#e8edf5",borderRadius:10,padding:4,maxWidth:320}}>
        {CATEGORIAS.map(function(t){
          return <button key={t[0]} onClick={function(){setTab(t[0]);setErr("");setEditingId(null);}} style={{flex:1,padding:"9px 0",borderRadius:8,border:"none",cursor:"pointer",fontSize:13,fontWeight:600,background:tab===t[0]?"#fff":"transparent",color:tab===t[0]?SIGTE_BRAND:"#64748b",boxShadow:tab===t[0]?"0 1px 4px rgba(0,0,0,0.08)":"none"}}>{t[1]}</button>;
        })}
      </div>
      {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 16px",fontSize:13,color:"#dc2626",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}><span>{err}</span><button onClick={function(){setErr("");}} style={{background:"none",border:"none",color:"#dc2626",cursor:"pointer",fontSize:16,fontWeight:700}}>X</button></div>:null}
      <Card sx={{marginBottom:20}}>
        <div style={{display:"flex",gap:10}}>
          <Inp placeholder={"Nuevo valor de "+tab} value={nuevo} onChange={function(e){setNuevo(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")add();}}/>
          <Btn onClick={add} sx={{whiteSpace:"nowrap"}}>Agregar</Btn>
        </div>
      </Card>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {rows.map(function(c){
          return (
            <Card key={c.id} sx={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,padding:"14px 18px"}}>
              {editingId===c.id?(
                <Inp value={editingValor} onChange={function(e){setEditingValor(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")saveEdit(c);}} sx={{maxWidth:260}}/>
              ):(
                <p style={{margin:0,fontSize:14,fontWeight:600,color:c.activo?"#0f172a":"#94a3b8"}}>{c.valor}{!c.activo?" (inactivo)":""}</p>
              )}
              <div style={{display:"flex",gap:8}}>
                {editingId===c.id?(
                  <button onClick={function(){saveEdit(c);}} style={{padding:"7px 14px",borderRadius:8,border:"none",background:SIGTE_BRAND,color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>Guardar</button>
                ):(
                  <button onClick={function(){startEdit(c);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer"}}>Editar</button>
                )}
                <button onClick={function(){toggleActivo(c);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer"}}>{c.activo?"Desactivar":"Activar"}</button>
                <button onClick={function(){del(c);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #fecaca",background:"#fef2f2",color:"#dc2626",fontSize:12,fontWeight:600,cursor:"pointer"}}>Eliminar</button>
              </div>
            </Card>
          );
        })}
        {rows.length===0?<p style={{color:"#94a3b8",fontSize:13}}>No hay valores en este catalogo.</p>:null}
      </div>
    </div>
  );
}
